var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEditar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_855",
    d: "M22.3,6.4l7.1,7.1L11.3,31.6l-7.1-7.1L22.3,6.4z M34.8,4.7l-3.2-3.2c-1.2-1.2-3.2-1.2-4.5,0l-3,3l7.1,7.1 l3.6-3.6C35.8,7.2,35.8,5.6,34.8,4.7C34.8,4.7,34.8,4.7,34.8,4.7z M0.5,34.5c-0.1,0.4,0.2,0.9,0.6,1c0.1,0,0.2,0,0.4,0l8-1.9 l-7.1-7.1L0.5,34.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditar01);
export default __webpack_public_path__ + "static/media/ico-editar-01.b094d163688e9f2878c8fd8bff1fa78d.svg";
export { ForwardRef as ReactComponent };